import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = ["aria-label"]
const _hoisted_2 = {
  key: 0,
  class: "feature-mosaic-grid__desktop feature-mosaic-grid__desktop--industrial",
  role: "list"
}
const _hoisted_3 = { class: "feature-mosaic-grid__industrial-row feature-mosaic-grid__industrial-row--top" }
const _hoisted_4 = { class: "feature-mosaic-grid__industrial-right" }
const _hoisted_5 = { class: "feature-mosaic-grid__industrial-top-cards" }
const _hoisted_6 = {
  key: 0,
  class: "feature-mosaic-grid__industrial-row feature-mosaic-grid__industrial-row--bottom"
}
const _hoisted_7 = {
  key: 1,
  class: "feature-mosaic-grid__desktop feature-mosaic-grid__desktop--mechanical",
  role: "list"
}
const _hoisted_8 = { class: "feature-mosaic-grid__mechanical-row" }
const _hoisted_9 = { class: "feature-mosaic-grid__mechanical-middle" }
const _hoisted_10 = { class: "feature-mosaic-grid__mechanical-cards" }
const _hoisted_11 = { class: "feature-mosaic-grid__mechanical-tall" }
const _hoisted_12 = {
  key: 2,
  class: "feature-mosaic-grid__desktop",
  role: "list"
}
const _hoisted_13 = { class: "feature-mosaic-grid__desktop-row feature-mosaic-grid__desktop-row--top" }
const _hoisted_14 = { class: "feature-mosaic-grid__desktop-right" }
const _hoisted_15 = { class: "feature-mosaic-grid__desktop-column feature-mosaic-grid__desktop-column--wide" }
const _hoisted_16 = { class: "feature-mosaic-grid__desktop-column feature-mosaic-grid__desktop-column--narrow" }
const _hoisted_17 = {
  key: 0,
  class: "feature-mosaic-grid__desktop-row feature-mosaic-grid__desktop-row--bottom"
}
const _hoisted_18 = {
  key: 3,
  class: "feature-mosaic-grid__mobile feature-mosaic-grid__mobile--industrial",
  role: "list"
}
const _hoisted_19 = {
  key: 1,
  class: "feature-mosaic-grid__industrial-mobile-panel feature-mosaic-grid__industrial-mobile-panel--top"
}
const _hoisted_20 = { class: "feature-mosaic-grid__industrial-mobile-top-cards" }
const _hoisted_21 = {
  key: 2,
  class: "feature-mosaic-grid__industrial-mobile-panel feature-mosaic-grid__industrial-mobile-panel--metrics"
}
const _hoisted_22 = { class: "feature-mosaic-grid__industrial-mobile-metric-row" }
const _hoisted_23 = { class: "feature-mosaic-grid__photo-stack" }
const _hoisted_24 = { class: "feature-mosaic-grid__industrial-mobile-metric-row" }
const _hoisted_25 = { class: "feature-mosaic-grid__photo-stack" }
const _hoisted_26 = {
  key: 4,
  class: "feature-mosaic-grid__mobile feature-mosaic-grid__mobile--mechanical",
  role: "list"
}
const _hoisted_27 = { class: "feature-mosaic-grid__mechanical-mobile-panel" }
const _hoisted_28 = { class: "feature-mosaic-grid__mechanical-middle" }
const _hoisted_29 = { class: "feature-mosaic-grid__mechanical-cards" }
const _hoisted_30 = { class: "feature-mosaic-grid__mechanical-tall" }
const _hoisted_31 = {
  key: 5,
  class: "feature-mosaic-grid__mobile",
  role: "list"
}
const _hoisted_32 = {
  key: 1,
  class: "feature-mosaic-grid__mobile-panel feature-mosaic-grid__mobile-panel--metrics"
}
const _hoisted_33 = { class: "feature-mosaic-grid__mobile-stack feature-mosaic-grid__mobile-stack--metrics" }
const _hoisted_34 = {
  key: 2,
  class: "feature-mosaic-grid__mobile-panel feature-mosaic-grid__mobile-panel--capability"
}
const _hoisted_35 = { class: "feature-mosaic-grid__mobile-stack feature-mosaic-grid__mobile-stack--top-left" }
const _hoisted_36 = { class: "feature-mosaic-grid__mobile-stack feature-mosaic-grid__mobile-stack--top-right" }
const _hoisted_37 = { class: "feature-mosaic-grid__mobile-stack feature-mosaic-grid__mobile-stack--bottom-left" }

import { computed } from 'vue'
import FeatureMosaicCard from './FeatureMosaicCard.vue'
import type { FeatureMosaicGroup, FeatureMosaicItem } from './featureMosaic'


export default /*@__PURE__*/_defineComponent({
  __name: 'FeatureMosaicGrid',
  props: {
    items: {},
    ariaLabel: { default: '' },
    layout: { default: 'publicSecurity' },
    mobileSplitIndex: { default: 0 },
    gap: { default: 'var(--police-feature-gap, var(--pixso-gap-md))' },
    cardRadius: { default: 'var(--police-card-radius, var(--pixso-radius-lg))' },
    compactCardRadius: { default: 'var(--police-card-radius-compact, var(--pixso-radius-md))' },
    bottomHeight: { default: 'var(--police-feature-bottom-height, 514px)' }
  },
  setup(__props: any) {

const props = __props

const rootStyle = computed(() => ({
  '--feature-mosaic-gap-base': props.gap,
  '--feature-mosaic-card-radius': props.cardRadius,
  '--feature-mosaic-card-radius-compact': props.compactCardRadius,
  '--feature-mosaic-bottom-height': props.bottomHeight
}))

const isIndustrialLayout = computed(() => props.layout === 'industrial')
const isMechanicalLayout = computed(() => props.layout === 'mechanical')

const groupedItems = computed(() => props.items.reduce<Record<FeatureMosaicGroup, FeatureMosaicItem[]>>((groups, item) => {
  const group = item.group || (item.variant === 'hero' ? 'hero' : 'topWide')
  groups[group].push(item)
  return groups
}, {
  hero: [],
  topWide: [],
  topNarrow: [],
  topFull: [],
  topCards: [],
  bottomLead: [],
  bottomLeftStack: [],
  bottomRightStack: [],
  bottomTrail: []
}))

const getGroupItems = (group: FeatureMosaicGroup) => groupedItems.value[group]

const desktopHero = computed(() => getGroupItems('hero')[0] || props.items[0])
const mobileHero = computed(() => desktopHero.value)

const mobileMetricLead = computed(() => getGroupItems('bottomLead')[0])
const mobileMetricStackItems = computed(() => getGroupItems('bottomLeftStack'))
const mobileTopLeftItems = computed(() => getGroupItems('topWide'))
const mobileTopRightItems = computed(() => getGroupItems('topNarrow'))
const mobileBottomLeftItems = computed(() => getGroupItems('bottomRightStack'))
const mobileStatsItem = computed(() => getGroupItems('bottomTrail')[0])
const hasBottomRow = computed(() => (
  getGroupItems('bottomLead').length > 0 ||
  getGroupItems('bottomLeftStack').length > 0 ||
  getGroupItems('bottomRightStack').length > 0 ||
  getGroupItems('bottomTrail').length > 0
))
const hasMobileCapabilityPanel = computed(() => (
  mobileTopLeftItems.value.length > 0 ||
  mobileTopRightItems.value.length > 0 ||
  mobileBottomLeftItems.value.length > 0 ||
  Boolean(mobileStatsItem.value)
))

const desktopStacks = computed(() => [
  { key: 'bottom-left-stack', items: getGroupItems('bottomLeftStack') },
  { key: 'bottom-right-stack', items: getGroupItems('bottomRightStack') }
].filter((stack) => stack.items.length > 0))

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "feature-mosaic-grid",
    "aria-label": _ctx.ariaLabel,
    style: _normalizeStyle(rootStyle.value),
    "data-text-reveal": "off"
  }, [
    (isIndustrialLayout.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            (desktopHero.value)
              ? (_openBlock(), _createBlock(FeatureMosaicCard, {
                  key: 0,
                  item: desktopHero.value,
                  role: "listitem"
                }, null, 8, ["item"]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_4, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getGroupItems('topFull'), (item) => {
                return (_openBlock(), _createBlock(FeatureMosaicCard, {
                  key: item.key,
                  item: item,
                  role: "listitem"
                }, null, 8, ["item"]))
              }), 128)),
              _createElementVNode("div", _hoisted_5, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getGroupItems('topCards'), (item) => {
                  return (_openBlock(), _createBlock(FeatureMosaicCard, {
                    key: item.key,
                    item: item,
                    role: "listitem"
                  }, null, 8, ["item"]))
                }), 128))
              ])
            ])
          ]),
          (hasBottomRow.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getGroupItems('bottomLead'), (item) => {
                  return (_openBlock(), _createBlock(FeatureMosaicCard, {
                    key: item.key,
                    item: item,
                    role: "listitem"
                  }, null, 8, ["item"]))
                }), 128)),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(desktopStacks.value, (stack) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: stack.key,
                    class: "feature-mosaic-grid__photo-stack"
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(stack.items, (item) => {
                      return (_openBlock(), _createBlock(FeatureMosaicCard, {
                        key: item.key,
                        item: item,
                        role: "listitem"
                      }, null, 8, ["item"]))
                    }), 128))
                  ]))
                }), 128)),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getGroupItems('bottomTrail'), (item) => {
                  return (_openBlock(), _createBlock(FeatureMosaicCard, {
                    key: item.key,
                    item: item,
                    role: "listitem"
                  }, null, 8, ["item"]))
                }), 128))
              ]))
            : _createCommentVNode("", true)
        ]))
      : (isMechanicalLayout.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              (desktopHero.value)
                ? (_openBlock(), _createBlock(FeatureMosaicCard, {
                    key: 0,
                    item: desktopHero.value,
                    role: "listitem"
                  }, null, 8, ["item"]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_9, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getGroupItems('topFull'), (item) => {
                  return (_openBlock(), _createBlock(FeatureMosaicCard, {
                    key: item.key,
                    item: item,
                    role: "listitem"
                  }, null, 8, ["item"]))
                }), 128)),
                _createElementVNode("div", _hoisted_10, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getGroupItems('topCards'), (item) => {
                    return (_openBlock(), _createBlock(FeatureMosaicCard, {
                      key: item.key,
                      item: item,
                      role: "listitem"
                    }, null, 8, ["item"]))
                  }), 128))
                ])
              ]),
              _createElementVNode("div", _hoisted_11, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getGroupItems('topNarrow'), (item) => {
                  return (_openBlock(), _createBlock(FeatureMosaicCard, {
                    key: item.key,
                    item: item,
                    role: "listitem"
                  }, null, 8, ["item"]))
                }), 128))
              ])
            ])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, [
              (desktopHero.value)
                ? (_openBlock(), _createBlock(FeatureMosaicCard, {
                    key: 0,
                    item: desktopHero.value,
                    role: "listitem"
                  }, null, 8, ["item"]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("div", _hoisted_15, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getGroupItems('topWide'), (item) => {
                    return (_openBlock(), _createBlock(FeatureMosaicCard, {
                      key: item.key,
                      item: item,
                      role: "listitem"
                    }, null, 8, ["item"]))
                  }), 128))
                ]),
                _createElementVNode("div", _hoisted_16, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getGroupItems('topNarrow'), (item) => {
                    return (_openBlock(), _createBlock(FeatureMosaicCard, {
                      key: item.key,
                      item: item,
                      role: "listitem"
                    }, null, 8, ["item"]))
                  }), 128))
                ])
              ])
            ]),
            (hasBottomRow.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getGroupItems('bottomLead'), (item) => {
                    return (_openBlock(), _createBlock(FeatureMosaicCard, {
                      key: item.key,
                      item: item,
                      role: "listitem"
                    }, null, 8, ["item"]))
                  }), 128)),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(desktopStacks.value, (stack) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: stack.key,
                      class: "feature-mosaic-grid__photo-stack"
                    }, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(stack.items, (item) => {
                        return (_openBlock(), _createBlock(FeatureMosaicCard, {
                          key: item.key,
                          item: item,
                          role: "listitem"
                        }, null, 8, ["item"]))
                      }), 128))
                    ]))
                  }), 128)),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getGroupItems('bottomTrail'), (item) => {
                    return (_openBlock(), _createBlock(FeatureMosaicCard, {
                      key: item.key,
                      item: item,
                      role: "listitem"
                    }, null, 8, ["item"]))
                  }), 128))
                ]))
              : _createCommentVNode("", true)
          ])),
    (isIndustrialLayout.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
          (mobileHero.value)
            ? (_openBlock(), _createBlock(FeatureMosaicCard, {
                key: 0,
                item: mobileHero.value,
                compact: "",
                role: "listitem"
              }, null, 8, ["item"]))
            : _createCommentVNode("", true),
          (getGroupItems('topFull').length || getGroupItems('topCards').length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getGroupItems('topFull'), (item) => {
                  return (_openBlock(), _createBlock(FeatureMosaicCard, {
                    key: item.key,
                    item: item,
                    compact: "",
                    role: "listitem"
                  }, null, 8, ["item"]))
                }), 128)),
                _createElementVNode("div", _hoisted_20, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getGroupItems('topCards'), (item) => {
                    return (_openBlock(), _createBlock(FeatureMosaicCard, {
                      key: item.key,
                      item: item,
                      compact: "",
                      role: "listitem"
                    }, null, 8, ["item"]))
                  }), 128))
                ])
              ]))
            : _createCommentVNode("", true),
          (hasBottomRow.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                _createElementVNode("div", _hoisted_22, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getGroupItems('bottomLead'), (item) => {
                    return (_openBlock(), _createBlock(FeatureMosaicCard, {
                      key: item.key,
                      item: item,
                      compact: "",
                      role: "listitem"
                    }, null, 8, ["item"]))
                  }), 128)),
                  _createElementVNode("div", _hoisted_23, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getGroupItems('bottomLeftStack'), (item) => {
                      return (_openBlock(), _createBlock(FeatureMosaicCard, {
                        key: item.key,
                        item: item,
                        compact: "",
                        role: "listitem"
                      }, null, 8, ["item"]))
                    }), 128))
                  ])
                ]),
                _createElementVNode("div", _hoisted_24, [
                  _createElementVNode("div", _hoisted_25, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getGroupItems('bottomRightStack'), (item) => {
                      return (_openBlock(), _createBlock(FeatureMosaicCard, {
                        key: item.key,
                        item: item,
                        compact: "",
                        role: "listitem"
                      }, null, 8, ["item"]))
                    }), 128))
                  ]),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getGroupItems('bottomTrail'), (item) => {
                    return (_openBlock(), _createBlock(FeatureMosaicCard, {
                      key: item.key,
                      item: item,
                      compact: "",
                      role: "listitem"
                    }, null, 8, ["item"]))
                  }), 128))
                ])
              ]))
            : _createCommentVNode("", true)
        ]))
      : (isMechanicalLayout.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
            (mobileHero.value)
              ? (_openBlock(), _createBlock(FeatureMosaicCard, {
                  key: 0,
                  item: mobileHero.value,
                  compact: "",
                  role: "listitem"
                }, null, 8, ["item"]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_27, [
              _createElementVNode("div", _hoisted_28, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getGroupItems('topFull'), (item) => {
                  return (_openBlock(), _createBlock(FeatureMosaicCard, {
                    key: item.key,
                    item: item,
                    compact: "",
                    role: "listitem"
                  }, null, 8, ["item"]))
                }), 128)),
                _createElementVNode("div", _hoisted_29, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getGroupItems('topCards'), (item) => {
                    return (_openBlock(), _createBlock(FeatureMosaicCard, {
                      key: item.key,
                      item: item,
                      compact: "",
                      role: "listitem"
                    }, null, 8, ["item"]))
                  }), 128))
                ])
              ]),
              _createElementVNode("div", _hoisted_30, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getGroupItems('topNarrow'), (item) => {
                  return (_openBlock(), _createBlock(FeatureMosaicCard, {
                    key: item.key,
                    item: item,
                    compact: "",
                    role: "listitem"
                  }, null, 8, ["item"]))
                }), 128))
              ])
            ])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_31, [
            (mobileHero.value)
              ? (_openBlock(), _createBlock(FeatureMosaicCard, {
                  key: 0,
                  item: mobileHero.value,
                  compact: "",
                  role: "listitem"
                }, null, 8, ["item"]))
              : _createCommentVNode("", true),
            (mobileMetricLead.value || mobileMetricStackItems.value.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                  (mobileMetricLead.value)
                    ? (_openBlock(), _createBlock(FeatureMosaicCard, {
                        key: 0,
                        class: "feature-mosaic-grid__mobile-metric-lead",
                        item: mobileMetricLead.value,
                        compact: "",
                        role: "listitem"
                      }, null, 8, ["item"]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_33, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(mobileMetricStackItems.value, (item) => {
                      return (_openBlock(), _createBlock(FeatureMosaicCard, {
                        key: item.key,
                        item: item,
                        compact: "",
                        role: "listitem"
                      }, null, 8, ["item"]))
                    }), 128))
                  ])
                ]))
              : _createCommentVNode("", true),
            (hasMobileCapabilityPanel.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                  _createElementVNode("div", _hoisted_35, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(mobileTopLeftItems.value, (item) => {
                      return (_openBlock(), _createBlock(FeatureMosaicCard, {
                        key: item.key,
                        item: item,
                        compact: "",
                        role: "listitem"
                      }, null, 8, ["item"]))
                    }), 128))
                  ]),
                  _createElementVNode("div", _hoisted_36, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(mobileTopRightItems.value, (item) => {
                      return (_openBlock(), _createBlock(FeatureMosaicCard, {
                        key: item.key,
                        item: item,
                        compact: "",
                        role: "listitem"
                      }, null, 8, ["item"]))
                    }), 128))
                  ]),
                  _createElementVNode("div", _hoisted_37, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(mobileBottomLeftItems.value, (item) => {
                      return (_openBlock(), _createBlock(FeatureMosaicCard, {
                        key: item.key,
                        item: item,
                        compact: "",
                        role: "listitem"
                      }, null, 8, ["item"]))
                    }), 128))
                  ]),
                  (mobileStatsItem.value)
                    ? (_openBlock(), _createBlock(FeatureMosaicCard, {
                        key: 0,
                        class: "feature-mosaic-grid__mobile-stats",
                        item: mobileStatsItem.value,
                        compact: "",
                        role: "listitem"
                      }, null, 8, ["item"]))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true)
          ]))
  ], 12, _hoisted_1))
}
}

})